const MESSAGES: Record<string, string> = {
  "No account found with this email":
    "لا يوجد حساب مرتبط بهذا البريد الإلكتروني",
};

export function toArabicAuthError(message: unknown, fallback: string): string {
  if (typeof message !== "string" || !message.trim()) return fallback;

  const exact = MESSAGES[message.trim()];
  if (exact) return exact;

  return fallback;
}
